import { ref, watch } from "vue";
import { useRoute, useRouter } from "vue-router";

export const useQFilter = () => {
  const q = ref<string | undefined>(undefined);

  const route = useRoute();
  const router = useRouter();

  watch(
    () => route.query,
    async (newParams, _oldParams) => {
      if (newParams.q !== q.value) {
        q.value = newParams.q ? `${newParams.q}` : undefined;
      }
    },
    { immediate: true },
  );

  const updateQFilter = async (updatedQ?: string) => {
    q.value = updatedQ;
    await router.push({ query: { ...route.query, q: updatedQ } });
  };

  return {
    q,
    updateQFilter,
  };
};
